import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import LeaveProfileGeneral from 'components/tables/leave_profile_general';
import LeaveProfileTabs2 from 'components/tables/leave_profile_tabs2';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import React, { useEffect, useState } from 'react';
import { Loading } from 'components';

const CreateLeaveProfile = () => {
  const [state, setState] = useState({
    finalData: {
      name: '',
      description: '',
      long_description: '',
      comment: '',
      french_description: '',
      french_long_description: '',
      french_comment: '',
      absence_types: [
        {
          absence_type_id: -1,
          is_active: true,
          priority: 0
        },
      ],
    },
    activeTab: '1',

  });
  const { finalData, activeTab, } = state;
  const { createLeaveProfile, getAbsenceTypesListAll } = useMember();
  const [loading, setLoading] = useState(false);
  const [absenceTypes1, setAbsenceTypes1] = useState([]);
  const [absenceTypes, setAbsenceTypes] = useState([]);
  const [errorName, setErrorName] = useState(null);
  const { successNotification, error } = useNotice();
  const addData = (data: any) => {
    setState((pre) => ({
      ...pre,
      finalData: Object.assign(finalData, data),
    }));
  };

  const submitData = () => {
    setLoading(true);
    setErrorName(null);
    const containsInvalidAbsenceType = finalData?.absence_types.some(type => type.absence_type_id === -1);

    if (containsInvalidAbsenceType) {
      error('Missing or incorrect information', 'Please define a type of leave');
      setState((pre) => ({ ...pre, activeTab: '2', }))
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      return;
    }
    createLeaveProfile(finalData)
      .then((res) => {
        setLoading(false);
        successNotification(
          `"${finalData?.name}" created successfully.`
        );

        setState((pre) => ({
          ...pre,
          finalData: {
            name: '',
            description: '',
            long_description: '',
            comment: '',
            french_description: '',
            french_long_description: '',
            french_comment: '',
            absence_types: [
              {
                absence_type_id: -1,
                is_active: true,
                priority: 0
              },
            ],
          },
          activeTab: '1'
        }));
        setAbsenceTypes1([]);
      })
      .catch((e) => {

        error('Missing or incorrect information', `"${finalData?.name}" already exists`, () => setErrorName('error'));
        setState((pre) => ({ ...pre, activeTab: '1', }))
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  };
  useEffect(() => {
    setLoading(true);
    getAbsenceTypesListAll().then((res) => {

      setAbsenceTypes(res.data);

      setLoading(false);
    });
  }, []);
  function addAbsenceTypesById(idToAdd, id) {
    const newArray = [...absenceTypes1];
    newArray.splice(id, 1, idToAdd);

    setAbsenceTypes1(newArray);
  }
  function deleteAbsenceTypesById(id: Number) {

    const newArray = absenceTypes1.filter((item, i) => i !== id);
    setAbsenceTypes1(newArray);
  }

  const handleTabChange = (key) => {
    setState((pre) => ({
      ...pre,
      activeTab: key,
    }));
  };


  if (loading) return <Loading />;
  return (
    <div>
      <GeneralHeader
        pageTitle="Create a new staff leave profile"
        icon="/assets/leave_profile.svg"
        child={
          <div style={{ marginTop: '65px', paddingBottom: '50px' }}>
            <div style={{
              justifyContent: 'flex-end',
              display: 'flex',
            }}>
              <button
                disabled={finalData?.name === ''}
                style={{
                  width: 40,
                  height: 40,
                  background: finalData?.name === '' ? '#E4E4E4' : '#407FDD',
                  border: finalData?.name === '' && '0.5px solid #E4E4E4'
                }}
                onClick={() => submitData()}
                className="header-button"
              >
                <img src="/icons/save.svg" alt="button" />
              </button>
            </div>
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={handleTabChange}
              items={[
                {
                  key: '1',
                  label: (
                    <div style={{
                      color: activeTab === '1' ? '#0E3063' : '#757575',
                      fontSize: '20px',
                      fontWeight: 600,
                      margin: '0px 10px'
                    }}>
                      General
                    </div>
                  ),
                  children: <LeaveProfileGeneral errorName={errorName} finalData={finalData} addData={addData} />,
                },
                {
                  key: '2',
                  label: (
                    <div style={{
                      color: activeTab === '2' ? '#0E3063' : '#757575',
                      fontSize: '20px',
                      fontWeight: 600,
                      margin: '0px 10px'
                    }}>
                      Staff Leave and Absence Types
                    </div>
                  ),
                  children: (
                    <LeaveProfileTabs2
                      data={finalData}
                      absenceTypes={absenceTypes}
                      absenceTypes1={absenceTypes1}
                      addData={addData}
                      checked={true}
                      addAbsenceTypesById={addAbsenceTypesById}
                      deleteAbsenceTypesById={deleteAbsenceTypesById}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default CreateLeaveProfile;
